import React from 'react';
import PropTypes from 'prop-types';
import BackButton from './BackButton';
import ScheduleCampaign from './ScheduleCampaign';
import ScheduleRecurringCampaignContainer from '../containers/ScheduleRecurringCampaign';
import { CAMPAIGN_TYPE } from '../constants';

const CampaignPayActions = ({
  campaignId,
  onScheduleClick,
  onPayNowClick,
  scheduleIsOn,
  closeSchedule,
  onDateChange,
  onDateStartChange,
  onDateEndChange,
  startDate,
  endDate,
  setEndDate,
  onTimeChange,
  scheduleCampaign,
  date,
  submittingIsOn,
  onRecurringScheduleClick,
  campaignType,
  isLapsedCampaign,
  onFrequencyChange,
  onRecurringSendToAllCustomers,
  onRecurringTimeChange,
}) => (
  <div className="layout layout--auto layout--small layout--middle">
    <div className="layout__item u-hidden-for-medium-and-down">
      <BackButton to={`/engagement/${campaignId}`} />
    </div>

    <div className="layout__item" display-if={campaignType !== CAMPAIGN_TYPE.recurring}>
      <button
        type="button"
        className="c-btn c-btn--medium"
        onClick={onScheduleClick}
        disabled={submittingIsOn}
      >
        Schedule
        </button>
    </div>
    <div className="layout__item" display-if={campaignType !== CAMPAIGN_TYPE.recurring}>
      <button
        type="button"
        className="c-btn c-btn--medium"
        onClick={onPayNowClick}
        disabled={submittingIsOn}
      >
        Send now
        </button>
      <ScheduleCampaign
        onDateChange={onDateChange}
        onTimeChange={onTimeChange}
        scheduleCampaign={scheduleCampaign}
        close={closeSchedule}
        currentDate={date}
        display-if={scheduleIsOn}
        submitting={submittingIsOn}
      />
    </div>
    <div className="layout__item" display-if={campaignType === CAMPAIGN_TYPE.recurring}>
      <button
        type="button"
        className="c-btn c-btn--medium"
        onClick={onRecurringScheduleClick}
        disabled={submittingIsOn}
      >
        Schedule
      </button>
      <ScheduleRecurringCampaignContainer
        close={closeSchedule}
        currentDate={date}
        display-if={scheduleIsOn}
        endDate={endDate}
        setEndDate={setEndDate}
        isLapsedCampaign={isLapsedCampaign}
        onDateEndChange={onDateEndChange}
        onDateStartChange={onDateStartChange}
        onFrequencyChange={onFrequencyChange}
        onRecurringSendToAllCustomers={onRecurringSendToAllCustomers}
        onRecurringTimeChange={onRecurringTimeChange}
        time={'00:00'}
        scheduleCampaign={scheduleCampaign}
        startDate={startDate}
        submitting={submittingIsOn}
      />
    </div>
  </div>
);

CampaignPayActions.propTypes = {
  campaignId: PropTypes.string.isRequired,
  onScheduleClick: PropTypes.func.isRequired,
  onPayNowClick: PropTypes.func.isRequired,
  onRecurringScheduleClick: PropTypes.func.isRequired,
  scheduleIsOn: PropTypes.bool.isRequired,
  scheduleCampaign: PropTypes.func.isRequired,
  closeSchedule: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onDateStartChange: PropTypes.func.isRequired,
  onDateEndChange: PropTypes.func,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setEndDate: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  submittingIsOn: PropTypes.bool.isRequired,
  campaignType: PropTypes.string.isRequired,
  isLapsedCampaign: PropTypes.bool.isRequired,
  onFrequencyChange: PropTypes.func.isRequired,
  onRecurringSendToAllCustomers: PropTypes.func.isRequired,
  onRecurringTimeChange: PropTypes.func.isRequired,
};

CampaignPayActions.defaultProps = {
  onDateEndChange: () => null,
};

export default CampaignPayActions;
